import { useEffect, useState } from "react";
import LoadingStuck from "../../reuse/LoadingStuck";
import Api from "../../../api/Api";
import { Button, Card, Col, Form, Nav, Row } from "react-bootstrap";
import Select from "react-select";
import countByFormulaTotal from "../../reuse/countByFormulaTotal";
import ComparisonGraficBarChar from "../../reuse/ComparisonGraficBarChar";

const getAuditData = async(auditId) =>{
    try {
        const response =await Api({
            method:"get",
            url:`/audits/@${auditId}/results`,
            headers:{}
        });
        return response;
    } catch (error) {
        throw error
    }
}

const CompareGraficInterface = ({dataFirst,dataSecond, testParts}) => {
    const countDataFirst=countByFormulaTotal(dataFirst.results, dataFirst.coefficients);
    const countDataSecond=countByFormulaTotal(dataSecond.results, dataSecond.coefficients);

    const graficDataFirst={};
    countDataFirst.data_count.forEach((item)=>{ graficDataFirst[item.name]=item.value});

    const graficDataSecond = {};
    countDataSecond.data_count.map((item)=>{graficDataSecond[item.name]=item.value});
    
    const mergedData = testParts.map((elem) => { 
        return {name:elem, valueFirst: graficDataFirst[elem] || 0, valueSecond:graficDataSecond[elem] || 0}
    });

    return(
        <>
        <Card className="mt-2">
            <Card.Header>Итоговая оценка аудитов</Card.Header>
            <Card.Body>
                <Row>
                    <Col md={6}>
                        <Form.Text>{dataFirst.name}</Form.Text>
                        <Form.Control readOnly value={countDataFirst.summary} disabled/>
                    </Col>
                    <Col md={6}>
                        <Form.Text>{dataSecond.name}</Form.Text>
                        <Form.Control readOnly value={countDataSecond.summary} disabled/>
                    </Col>
                </Row>
            </Card.Body>
        </Card>
        <Card className="mt-2 mb-2">
            <Card.Header>График сравнения аудита {dataFirst.name} и {dataSecond.name}</Card.Header>
            <Card.Body>
                <ComparisonGraficBarChar data={mergedData} labels={{firstLabel:dataFirst.name,secondLabel:dataSecond.name}}/>
            </Card.Body>
        </Card>
        </>
    )
}

const FetchAuditData = ({firstAudit, secondAudit, testParts}) => {
    const [loading,setLoading]=useState(false);
    const [error,setError]=useState(false);
    const [block,setBlock]=useState(false)

    const [errorInfo,setErrorInfo]=useState(null);

    const [dataFirst,setDataFirst]=useState(null);
    const [dataSecond,setDataSecond]=useState(null);

    const getAllData = async() => {
        try {
            const auditDatafirst= await getAuditData(firstAudit);
            const auditDatasecond= await getAuditData(secondAudit);
            setDataFirst(auditDatafirst.data);
            setDataSecond(auditDatasecond.data);
            setBlock(true);
        } catch (error) {
            // setErrorInfo("Ошибка при подгрузке данных аудита");
            setErrorInfo(error);
            setError(true);
        }
    }

    useEffect(()=>{
        const setUp = async() => {
            setLoading(true)
            await getAllData();
            setLoading(false)
        }
        setUp();
    },[firstAudit,secondAudit])

    if(loading){return(<LoadingStuck/>)}
    if(error){return(<p className="warning_text">{errorInfo}</p>)}
    if(block){return(<CompareGraficInterface dataFirst={dataFirst} dataSecond={dataSecond} testParts={testParts}/>)}
}

const ComparisonAuditForm = ({auditsData,testParts}) => {
    const [firstAudit,setFirstAudit]=useState(null);
    const [secondAudit,setSecondAudit]=useState(null);

    if(auditsData.length==0){return(<p>Данных об аудитах нет. Создайте хотя бы один аудит.</p>)}

    const auditOptions = auditsData.map((item)=>{return {label:item.name,value:item.id}})

    const renderGrafics = () => {
        if(firstAudit!==null && secondAudit!==null){
            // return(<p>{JSON.stringify(firstAudit)} - {JSON.stringify(secondAudit)}</p>)
            return(<FetchAuditData 
                firstAudit={firstAudit} 
                secondAudit={secondAudit} 
                testParts={testParts}/>)
        }
    }
    return(
        <>
            <Card className="mt-2">
                <Form>
                <Card.Header>Выберите 2 аудита</Card.Header>
                <Card.Body>
                        <Row className="mb-2">
                            <Col md={6}>
                                <Form.Text>Первый аудит</Form.Text>
                                <Select
                                options={auditOptions}
                                onChange={(e)=>{setFirstAudit(e?.value || null)}}
                                isClearable
                                placeholder="Выберите первый аудит"/>
                            </Col>
                            <Col md={6}>
                                <Form.Text>Второй аудит</Form.Text>
                                <Select
                                options={auditOptions}
                                onChange={(e)=>{setSecondAudit(e?.value || null)}}
                                isClearable
                                placeholder="Выберите второй аудит"/>
                            </Col>
                        </Row>
                </Card.Body>
                </Form>
            </Card>
            {renderGrafics()}
        </>
    )
}

const FetchData = ({testId, testParts}) => {
    const [loading,setLoading]=useState(false);
    const [error,setError]=useState(false);
    const [block,setBlock]=useState(false);

    const [errorInfo,setErrorInfo]=useState(null);
    const [data,setData]=useState(null);

    const getAuditsData = async() => {
        try {
            const response = await Api({
                method:"get",
                url:`/audits/my_audits/all?${testId}`,
                headers:{}
            })
            setData(response.data);
            setBlock(true);
        } catch (error) {
            // setErrorInfo("Ошибка при подгрузке всех аудитов");
            setErrorInfo(`Ошибка при подгрузке всех аудитов \n ${error}`);
            setError(true);
        }
    } 

    useEffect(()=>{
        const setUp = async() => {
            setLoading(true)
            await getAuditsData();
            setLoading(false);
        }
        setUp();
    },[])

    if(loading){return(<LoadingStuck/>)}
    if(error){return(<p className="warning_text">{errorInfo}</p>)}
    if(block){return(<ComparisonAuditForm auditsData={data} testParts={testParts}/>)}
}

const ChoseTestForm = ({testsData}) => {
    const [testId,setTestId]=useState(null);
    if(testsData.length==0){<p>Нет ни одного теста. Создайте хотя бы один тест!</p>}

    const testOptions = testsData.map((item)=>{return {label:item.name, value:item.id}})

    const renderForm = () => {
        if (testId!==null){
            const testParts = testsData.filter((item)=>{if(item.id==testId){return true}})[0]
            const testPartsNames=Object.keys(testParts.coefficients)
            return(<FetchData testId={testId} testParts={testPartsNames}/>)
        }
    }

    return(
        <>
        {/* {JSON.stringify(testOptions)} */}
        <Card>
            <Card.Header>Выберите тест</Card.Header>
            <Card.Body>
                <Select 
                placeholder="Выберите тест..." 
                isClearable
                options={testOptions}
                onChange={(e)=>{setTestId(e?.value || null)}}/>
            </Card.Body>
        </Card>
        {renderForm()}
        </>
    )

}

const FetchDataTest = () => {
    const [loading,setLoading]=useState(false);
    const [error,setError]=useState(false);
    const [block,setBlock]=useState(false);

    const [errorInfo,setErrorInfo]=useState(null);
    const [data,setData]=useState(null);

    const getTestsData = async() => {
        try {
            const response = await Api({
                method:"get",
                url:`/tests/`,
                headers:{}
            })
            setData(response.data);
            setBlock(true);
        } catch (error) {
            // setErrorInfo("Ошибка при подгрузке всех тестов");
            setErrorInfo(`Ошибка при подгрузке всех тестов \n ${error}`);
            setError(true);
        }
    } 

    useEffect(()=>{
        const setUp = async() => {
            setLoading(true)
            await getTestsData();
            setLoading(false);
        }
        setUp();
    },[])

    if(loading){return(<LoadingStuck/>)}
    if(error){return(<p className="warning_text">{errorInfo}</p>)}
    if(block){return(<ChoseTestForm testsData={data}/>)}
}

const ComparisonAuditsBlock = () => {
    return(<FetchDataTest/>)
}

export default ComparisonAuditsBlock;